"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HilPackageFunction = void 0;
const z = __importStar(require("zod"));
const merge_values_js_1 = require("../utils/merge-values.js");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const hil_package_function_signal_js_1 = require("./hil-package-function-signal.js");
const merge_records_js_1 = require("../utils/merge-records.js");
const merge_records_dto_schema_js_1 = require("../utils/merge-records-dto-schema.js");
const hilPackageFunctionSchema = z.object({
    id: z.string(),
    functionClass: z.string().nullable().default(null),
    name: z.string(),
    busRole: z.nativeEnum(sigma_engine_shared_1.ComponentFunctionBusRole).nullable().default(null),
    mustBeAssigned: z.boolean().nullable().default(null),
    classParameters: sigma_engine_shared_1.IComponentFunctionClassParametersSchema.nullable().default(null),
    conditions: sigma_engine_shared_1.IFunctionConditionSchema.array().nullable().default(null),
    resourceConsumed: z.string().nullable().default(null),
    boundaries: sigma_engine_shared_1.IComponentFunctionBoundarySchema.array().nullable().default(null),
    functionSignals: z.record(z.string(), hil_package_function_signal_js_1.HilPackageFunctionSignal.schema),
});
const hilPackageFunctionDtoSchema = z.object({
    functionClass: z.string().optional(),
    name: z.string().optional(),
    busRole: z.nativeEnum(sigma_engine_shared_1.ComponentFunctionBusRole).nullable().optional(),
    mustBeAssigned: z.boolean().nullable().optional(),
    classParameters: sigma_engine_shared_1.IComponentFunctionClassParametersSchema.optional(),
    conditions: sigma_engine_shared_1.IFunctionConditionSchema.array().optional(),
    resourceConsumed: z.string().nullable().optional(),
    boundaries: sigma_engine_shared_1.IComponentFunctionBoundarySchema.array().optional(),
    functionSignals: (0, merge_records_dto_schema_js_1.mergeRecordsDtoSchema)(hil_package_function_signal_js_1.HilPackageFunctionSignal.schema, hil_package_function_signal_js_1.HilPackageFunctionSignal.dtoSchema).optional(),
});
exports.HilPackageFunction = {
    create: (input) => {
        return hilPackageFunctionSchema.parse({
            ...input,
            id: (0, cadstrom_shared_1.generateReadableId)(cadstrom_shared_1.CadstromObjectType.PackageFunction, input.name ?? ''),
        });
    },
    merge: (existing, incoming) => ({
        id: existing.id,
        functionClass: (0, merge_values_js_1.mergeValues)(existing.functionClass, incoming.functionClass),
        name: (0, merge_values_js_1.mergeValues)(existing.name, incoming.name),
        busRole: (0, merge_values_js_1.mergeValues)(existing.busRole, incoming.busRole),
        mustBeAssigned: (0, merge_values_js_1.mergeValues)(existing.mustBeAssigned, incoming.mustBeAssigned),
        classParameters: (0, merge_values_js_1.mergeValues)(existing.classParameters, incoming.classParameters),
        conditions: (0, merge_values_js_1.mergeValues)(existing.conditions, incoming.conditions),
        resourceConsumed: (0, merge_values_js_1.mergeValues)(existing.resourceConsumed, incoming.resourceConsumed),
        boundaries: (0, merge_values_js_1.mergeValues)(existing.boundaries, incoming.boundaries),
        functionSignals: (0, merge_records_js_1.mergeRecords)(existing.functionSignals, incoming.functionSignals, hil_package_function_signal_js_1.HilPackageFunctionSignal.merge),
    }),
    schema: hilPackageFunctionSchema,
    dtoSchema: hilPackageFunctionDtoSchema,
};
//# sourceMappingURL=hil-package-function.js.map